<script setup lang="ts">
  import type { Integration } from '@stuut/api/models';
  import { HoverCard, HoverCardContent, HoverCardTrigger } from '@ui/components/hover-card';
  import { cn } from '@ui/utils/utils';

  import IntegrationThumbnail from '@/components/integrations/IntegrationThumbnail.vue';

  interface Props {
    integration: Integration;
    lastSyncedAt?: string;
    name?: string;
    noIcon?: boolean;
    small?: boolean;
  }

  const props = defineProps<Props>();
</script>

<template>
  <HoverCard>
    <div :class="cn('flex items-center', small ? 'gap-2' : 'gap-4')">
      <IntegrationThumbnail
        v-if="!noIcon"
        :integration="integration"
        :class="cn('rounded', small ? 'size-4' : '')"
      />
      <HoverCardTrigger as-child>
        <slot>
          <span>
            <span v-if="name" class="font-semibold mr-1">{{ name }}</span>

            <span :class="cn('select-none', name ? 'text-muted-foreground' : 'font-semibold')">
              <span v-if="name">(</span>{{ integration.display_name }}<span v-if="name">)</span>
            </span>
          </span>
        </slot>
      </HoverCardTrigger>
    </div>

    <HoverCardContent v-if="lastSyncedAt" class="w-fit">
      Last Sync:
      <span class="font-semibold">
        {{ lastSyncedAt }}
      </span>
    </HoverCardContent>
  </HoverCard>
</template>

<style scoped></style>
